// @flow

import { createReducer } from 'redux-act';

import type { Service, State } from '../../types/marketplace';

import { resource } from './index';

// reducers
const initialState: State = {};

const fetchDomainServicesHandler = (
  state: State,
  { response: { data: services }, label: fqdn }: any,
): State => {
  const prevServices = state[fqdn] || [];
  const nextServices = [];
  services.forEach(service => {
    const prevService = prevServices.find(
      s => s.service_id === service.service_id,
    );
    nextServices.push({ ...(prevService || {}), ...service });
  });
  return { ...state, [fqdn]: nextServices };
};

const addOrUpdateService = (prevServices: Array<Service>, service: Service) => {
  const services = [...prevServices];
  const index = services.findIndex(s => s.service_id === service.service_id);
  if (index >= 0) {
    services[index] = { ...services[index], ...service };
  } else {
    services.push(service);
  }
  return services;
};

const fetchDomainServiceHandler = (
  state: State,
  { response: { data: service } }: any,
): State => {
  const { fqdn } = service;
  const prevServices = state[fqdn] || [];
  return { ...state, [fqdn]: addOrUpdateService(prevServices, service) };
};

export default (createReducer(
  {
    [resource.fetch.success.getType()]: fetchDomainServicesHandler,
    [resource.fetchOne.success.getType()]: fetchDomainServiceHandler,
  },
  initialState,
): {
  (): (state: State, payload?: mixed, meta?: mixed) => State,
  assignAll: ({ ... } | Array<mixed>, { ... } | Array<mixed>) => mixed,
  batch: ({ ... } | Array<mixed>) => mixed,
  bindAll: ({ ... } | Array<mixed>, { ... } | Array<mixed>) => mixed,
  disbatch: (mixed, void | Array<mixed>) => mixed,
  has: (actionCreator: mixed) => boolean,
  // $FlowFixMe[cannot-resolve-name]
  off: Reducer$Off,
  // $FlowFixMe[cannot-resolve-name]
  on: Reducer$On<State>,
  options: () => mixed,
  ...
});
